/**
 * The shell's icons — TRBUD-439, design v1 (a) "Icons".
 *
 * One consistent set: a 24-unit box, a 1.5 stroke, round caps and joins, no
 * fill, drawn in `currentColor` so the active, muted and hover colours come from
 * the rule around the icon. Every menu destination has one (Attendance review
 * had none), and the rail, the drawer, the phone bar and the More sheet all read
 * this one table, so a page cannot carry two different pictures.
 *
 * The app has no icon library and this does not add one: these are the paths the
 * approved design draws (its sprite in `01-app-shell-nav/v6/*.html`).
 */
const PATHS = {
  "work-orders": "M9 3h6v3H9z M7 5H5v16h14V5h-2 M8 11h8 M8 15h6",
  requests: "M3 13v7h18v-7 M3 13h5l2 3h4l2-3h5 M3 13l3-9h12l3 9",
  overview: "M3 4h5v16H3z M10 4h5v11h-5z M17 4h4v8h-4z",
  attendance: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M2 21v-1a5 5 0 0 1 5-5h4 M15 19l2 2 4-4",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2",
  assets: "M1 7h13v10H1z M14 11h4l3 3v3h-7 M5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M17 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  board: "M3 4h18v12H3z M8 20h8 M12 16v4 M7 12l3-4 3 3 4-5",
  parts: "M12 2 3 7v10l9 5 9-5V7z M3 7l9 5 9-5 M12 12v10",
  "purchase-orders": "M5 3h14v18l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5L7 21l-2-1.5z M9 8h6 M9 12h6",
  vendors: "M3 9l1.5-5h15L21 9 M3 9h18v2.5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-3 0z M5 14v7h14v-7 M10 21v-5h4v5",
  review: "M6 2h9l5 5v15H6z M14 2v6h6 M9 15l2 2 4-4",
  spend: "M12 2v20 M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  downtime: "M3 12h4l3-7 4 14 3-7h4",
  saved: "M6 3h12v18l-6-4-6 4z",
  reports: "M3 3v18h18 M8 17v-7 M13 17V6 M18 17v-4",
  config: "M4 6h16 M4 12h16 M4 18h16 M8 4v4 M16 10v4 M10 16v4",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  search: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3",
  bell: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.7 21a2 2 0 0 1-3.4 0",
  moon: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z",
  "chevron-down": "M6 9l6 6 6-6",
  "chevron-right": "M9 6l6 6-6 6",
  panel: "M3 4h18v16H3z M9 4v16",
  close: "M18 6 6 18 M6 6l12 12",
  more: "M5 12h.01 M12 12h.01 M19 12h.01",
  "sign-out": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9",
  page: "M4 4h16v16H4z",
} as const;

export type NavIconName = keyof typeof PATHS;

/** Which picture each menu destination carries. A path with none gets the plain page. */
const DESTINATION_ICONS: Readonly<Record<string, NavIconName>> = {
  "/work-orders": "work-orders",
  "/requests": "requests",
  "/overview": "overview",
  "/attendance": "attendance",
  "/time-clock": "clock",
  "/assets": "assets",
  "/board": "board",
  "/parts": "parts",
  "/purchase-orders": "purchase-orders",
  "/vendors": "vendors",
  "/review": "review",
  "/reports/spend": "spend",
  "/reports/work": "downtime",
  "/reports/saved": "saved",
  "/config": "config",
  "/settings/connections": "panel",
  "/settings": "settings",
};

export function iconForPath(path: string): NavIconName {
  return DESTINATION_ICONS[path] ?? "page";
}

export function NavIcon({ name, className }: { name: NavIconName; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "more" ? 3 : 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
